module.exports = __webpack_public_path__ + "img/multimalla.e11b563c.jpg";